<template>
  <PBannerBase type="info">
    <template #title>
      <span style="font-size: 13px; font-weight: 600">
        {{ renderedLabel }}
      </span>
    </template>
    <div>
      <span class="banner-field-renderer__description">
        <InlineMarkdownText :text="renderedDescription" />
      </span>
    </div>
  </PBannerBase>
</template>

<script setup lang="ts">
import { PBannerBase } from "@f360-dev/f360-prisma";
import { computed } from "vue";
import InlineMarkdownText from "./InlineMarkdownText.vue";
import { TIntegracaoCampoModel } from "../../@types/IntegracaoCampoModel";
import useFieldTemplate from "../../composables/dynamicForm/handlers/useFieldTemplate/useFieldTemplate";

const props = defineProps<{
  campo: TIntegracaoCampoModel;
  formValues?: Record<string, unknown>;
}>();

const { renderTemplate } = useFieldTemplate();
const renderedLabel = computed(() =>
  renderTemplate(props.campo.label, props.formValues)
);
const renderedDescription = computed(() =>
  renderTemplate(props.campo.descricao, props.formValues)
);
</script>

<style scoped lang="scss">
.banner-field-renderer__description {
  white-space: pre-line;
  font-size: 12px;
  font-weight: 300;
}
</style>
